module.exports = __webpack_public_path__ + "static/media/kick-acoustic01.a1a216d6.wav";